import React from 'react';
import { useHistory } from 'react-router-dom';
import itemDefaultImage from '../../../Assets/Images/item-default-image.png';

const onThumbError = (e) => {
  e.currentTarget.onerror = null;
  e.currentTarget.src = itemDefaultImage;
};

const LectureThumb = ({ id, title, thumbnailUrl, onClick }) => (
  <div
    className="relative w-[210px] h-[158px] overflow-hidden bg-[#3a3a3a] cursor-pointer shrink-0 group"
    onClick={() => onClick && onClick(id)}
  >
    <img
      src={thumbnailUrl || itemDefaultImage}
      alt={title}
      className="w-full h-full object-cover"
      onError={onThumbError}
    />
    <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-10 transition-opacity duration-200 pointer-events-none" />
  </div>
);

// Figma: absolute top:571px (= 800-229), bg #4A4A4A, h 229px
// Lecture row: left calc(50%-1078/2), top 607px (= 571+36), gap 22px
// "대표 강의 |": Pretendard 700 24px white, letter-spacing -0.04em
const TopLectureBand = ({ topLectures = [] }) => {
  const history = useHistory();
  const goToLecture = (id) => history.push(`/lecture/${id}`);

  return (
    <div className="absolute left-0 w-full h-[229px] bg-[#4A4A4A] z-30 flex items-center" style={{ top: 571 }}>
      <div className="flex flex-row items-start gap-[22px]" style={{ marginLeft: 'calc(50% - 1078px/2)' }}>
        <span
          className="font-pretendard font-bold text-[24px] leading-[29px] text-white whitespace-nowrap shrink-0"
          style={{ letterSpacing: '-0.04em' }}
        >
          대표 강의 |
        </span>
        {topLectures && topLectures.length > 0 ? (
          topLectures
            .slice(0, 4)
            .map((lec) => (
              <LectureThumb
                key={lec.id}
                id={lec.id}
                title={lec.title}
                thumbnailUrl={lec.thumbnailUrl || lec.image_thumb}
                onClick={goToLecture}
              />
            ))
        ) : (
          <span className="font-pretendard text-[18px] text-white/60">등록된 대표 강의가 없습니다.</span>
        )}
      </div>
    </div>
  );
};

export default TopLectureBand;
